var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 54,
    viewBox: "0 0 51 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5194 33.2595L34.6948 33.2595C35.1238 33.2595 35.4746 33.6157 35.4746 34.0511V39.717C35.4746 40.1523 35.1238 40.5085 34.6948 40.5085L15.5194 40.5085C15.0905 40.5085 14.7396 40.1523 14.7396 39.717L14.7396 34.0514C14.7396 33.616 15.0905 33.2595 15.5194 33.2595Z",
    fill: "url(#paint0_linear_707_40756)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5175 9.43317L34.6929 9.43317C35.1218 9.43317 35.4727 9.7893 35.4727 10.2247V15.8906C35.4727 16.326 35.1218 16.6821 34.6929 16.6821L15.5175 16.6821C15.0885 16.6821 14.7376 16.326 14.7376 15.8906L14.7376 10.2247C14.7376 9.7893 15.0885 9.43317 15.5175 9.43317Z",
    fill: "url(#paint1_linear_707_40756)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1722 30.3925L16.1658 33.3635H17.4668L17.0474 29.6523L16.464 30.1798L16.1722 30.3925Z",
    fill: "url(#paint2_linear_707_40756)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0684 42.1836L25.0546 5.43275C25.0546 5.43275 19.031 5.35492 17.9805 6.74862C16.93 8.14233 14.2065 11.9461 16.6078 19.2209L17.7508 27.3565L18.0452 33.7443L18.095 38.3798L18.626 41.9896C18.626 41.9896 21.4983 42.7672 21.594 42.7672C21.6898 42.7672 25.0684 42.1836 25.0684 42.1836Z",
    fill: "url(#paint3_linear_707_40756)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9506 37.3961C18.9506 37.3961 18.9517 28.1032 19.582 24.8007L17.2546 20.3044C17.2546 20.3044 16.6405 19.3881 16.6073 19.2216L17.0483 32.5493L18.2821 37.0475L18.9506 37.3961Z",
    fill: "url(#paint4_linear_707_40756)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0488 29.9018C17.0488 29.9018 16.4471 30.4943 16.3559 30.5033C16.2648 30.5126 16.1372 30.4663 16.1736 30.3921C16.21 30.3182 17.0488 29.6515 17.0488 29.6515V29.9018Z",
    fill: "#252A29"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8094 32.5487C16.8094 32.5487 14.1379 33.9868 15.6696 39.5846C15.6696 39.5846 16.0459 41.4617 17.2529 42.5445C18.4599 43.6273 19.175 45.1608 19.4213 45.2164C19.6676 45.272 23.5479 45.4879 23.5479 45.4879L23.5684 42.0725L20.3392 41.9893C20.3392 41.9893 19.4563 41.9061 19.3821 41.2258C19.3079 40.5454 19.2531 38.3799 19.0892 37.7967C18.9249 37.2132 17.1561 32.965 16.8094 32.5487Z",
    fill: "url(#paint5_linear_707_40756)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0527 45.4877H23.5482L23.5698 41.9059L23.3292 33.0204L23.3175 17.6126C23.3175 17.6126 22.9776 10.1377 22.8094 8.50296C22.5222 5.71233 18.1316 6.64265 18.1316 6.64265C18.1316 6.64265 18.8701 5.50431 25.0524 5.50431L25.0524 45.4877H25.0527Z",
    fill: "#FFE4CA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0527 5.43293V5.57639C21.9098 5.57639 20.2124 5.87658 19.3418 6.12871C18.8415 6.2736 18.5493 6.41921 18.3843 6.52501C19.0825 6.41419 20.9703 6.21264 22.0763 7.03214C22.5451 7.37967 22.8158 7.87209 22.8797 8.49614C23.0462 10.114 23.3846 17.5351 23.3882 17.6097L23.3998 33.0208L23.6401 41.9041L23.6189 45.4159H25.0524V45.4877H23.4772L23.4988 41.9055L23.2585 33.0225L23.2468 17.6126C23.2437 17.5412 22.9052 10.124 22.7391 8.51048C22.6794 7.92876 22.4282 7.47005 21.9929 7.14762C20.6968 6.18753 18.1716 6.70757 18.1461 6.71294L17.9786 6.74845L18.0726 6.6032C18.1041 6.5555 18.9033 5.43293 25.0527 5.43293Z",
    fill: "#3E3E3E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.935 30.3913L33.9414 33.3624H32.6401L33.0598 29.6507L33.6432 30.1783L33.935 30.3913Z",
    fill: "url(#paint6_linear_707_40756)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0385 42.1828L25.0522 5.43196C25.0522 5.43196 31.0759 5.35413 32.1263 6.74783C33.1768 8.14154 35.9003 11.9453 33.499 19.2201L32.356 27.3557L32.0617 33.7435L32.0119 38.379L31.4808 41.9888C31.4808 41.9888 28.6085 42.7664 28.5128 42.7664C28.417 42.7664 25.0385 42.1828 25.0385 42.1828Z",
    fill: "url(#paint7_linear_707_40756)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1547 37.3948C31.1547 37.3948 31.1537 28.1019 30.5233 24.7995L32.8507 20.3031C32.8507 20.3031 33.4648 19.3868 33.498 19.2204L33.0571 32.548L31.8232 37.0462L31.1547 37.3948Z",
    fill: "url(#paint8_linear_707_40756)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0598 29.9015C33.0598 29.9015 33.6616 30.4939 33.7527 30.5029C33.8439 30.5119 33.9714 30.466 33.935 30.3917C33.8986 30.3179 33.0598 29.6511 33.0598 29.6511V29.9015Z",
    fill: "#252A29"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2964 32.5482C33.2964 32.5482 35.968 33.9863 34.4363 39.5841C34.4363 39.5841 34.06 41.4613 32.853 42.544C31.646 43.6268 30.9309 45.1603 30.6846 45.2159C30.4383 45.2715 26.558 45.4874 26.558 45.4874L26.5375 42.072L29.7666 41.9888C29.7666 41.9888 30.6496 41.9056 30.7238 41.2253C30.798 40.5449 30.8528 38.3794 31.0167 37.7962C31.181 37.2127 32.9502 32.9646 33.2964 32.5482Z",
    fill: "url(#paint9_linear_707_40756)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0535 45.4162H26.558L26.5365 41.8344L26.7771 32.9489L26.7887 17.5411C26.7887 17.5411 27.1286 10.0662 27.2968 8.43148C27.5841 5.64085 31.9746 6.57118 31.9746 6.57118C31.9746 6.57118 31.2294 5.50528 25.0472 5.50528L24.9899 32.2804L25.0535 45.4162Z",
    fill: "#FFE4CA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0529 5.43208V5.57554C28.1958 5.57554 29.8932 5.87572 30.7638 6.12785C31.2641 6.27275 31.5563 6.41836 31.7213 6.52416C31.0231 6.41334 29.1353 6.21178 28.0293 7.03129C27.5605 7.37881 27.2898 7.87123 27.2259 8.49528C27.0594 10.1131 26.721 17.5343 26.7174 17.6089L26.7058 33.0199L26.4655 41.9032L26.4867 45.4151H25.0532V45.4868H26.6284L26.6068 41.9047L26.8471 33.0217L26.8588 17.6117C26.8619 17.5404 27.2004 10.1232 27.3665 8.50963C27.4262 7.9279 27.6774 7.46919 28.1127 7.14677C29.4088 6.18667 31.934 6.70671 31.9595 6.71209L32.127 6.7476L32.033 6.60235C32.0019 6.555 31.2026 5.43208 25.0529 5.43208Z",
    fill: "#3E3E3E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0425 40.0449H25.0547V41.822H27.0425V40.0449Z",
    fill: "#787D7A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7093 41.225H25.0391V41.5582H25.7093V41.225Z",
    fill: "#1C1C2E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.725 40.6997H25.0547V41.0329H25.725V40.6997Z",
    fill: "#1C1C2E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.725 40.175H25.0547V40.5082H25.725V40.175Z",
    fill: "#1C1C2E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8973 41.2251H25.9277V41.5583H26.8973V41.2251Z",
    fill: "#1C1C2E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9188 40.7H25.9492V41.0332H26.9188V40.7Z",
    fill: "#1C1C2E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9168 40.1747H25.9473V40.5079H26.9168V40.1747Z",
    fill: "#1C1C2E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2405 6.64249V9.69673C29.2405 9.69673 33.1522 9.91873 33.4805 9.83553C33.4805 9.83553 32.7968 7.86405 32.3862 7.36445C31.976 6.8645 31.7297 6.64249 29.2405 6.64249Z",
    fill: "#363C47"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1624 7.87321C30.1624 7.87321 31.3089 7.74373 31.9746 7.96574C31.9746 7.96574 31.929 8.35451 31.8926 8.50263C31.8926 8.50263 30.7803 8.53957 30.4885 8.4101C30.4881 8.4101 30.1829 8.1508 30.1624 7.87321Z",
    fill: "#989898"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0668 41.8228H25.0547V40.0457H23.0668V41.8228Z",
    fill: "#787D7A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3981 41.5593H25.0684V41.2261H24.3981V41.5593Z",
    fill: "#1C1C2E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3844 41.0338H25.0547V40.7006H24.3844V41.0338Z",
    fill: "#1C1C2E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3844 40.5086H25.0547V40.1754H24.3844V40.5086Z",
    fill: "#1C1C2E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2101 41.5593H24.1797V41.2261H23.2101V41.5593Z",
    fill: "#1C1C2E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1887 41.0336H24.1582V40.7004H23.1887V41.0336Z",
    fill: "#1C1C2E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1887 40.5089H24.1582V40.1757H23.1887V40.5089Z",
    fill: "#1C1C2E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8691 6.64304V9.69728C20.8691 9.69728 16.9574 9.91928 16.6291 9.83607C16.6291 9.83607 17.3128 7.86459 17.7234 7.365C18.134 6.8654 18.3799 6.64304 20.8691 6.64304Z",
    fill: "#363C47"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9453 7.87437C19.9453 7.87437 18.7987 7.74489 18.1331 7.96689C18.1331 7.96689 18.1786 8.35567 18.215 8.50379C18.215 8.50379 19.3273 8.54073 19.6192 8.41126C19.6195 8.41126 19.9248 8.15196 19.9453 7.87437Z",
    fill: "#989898"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9081 25.496L31.1268 30.6698C31.1268 30.6698 32.2783 29.2729 32.5765 28.9114C32.8747 28.5495 32.8532 28.023 32.8532 28.023L32.8532 21.7477C32.6648 21.8772 30.9081 25.496 30.9081 25.496Z",
    fill: "url(#paint10_linear_707_40756)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8902 21.6798L32.8902 28.0225C32.8909 28.0429 32.9089 28.5658 32.6054 28.9342L31.097 30.7636L30.8741 25.4883L30.878 25.48C31.0582 25.1088 32.6443 21.8487 32.8351 21.7178L32.8902 21.6798ZM31.1596 30.5757L32.551 28.8882C32.8365 28.5418 32.8195 28.0293 32.8195 28.0243V21.8462C32.556 22.2411 31.5889 24.1781 30.9455 25.5037L31.1596 30.5757Z",
    fill: "#282828"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5327 28.9123C17.8309 29.2742 18.9825 30.6708 18.9825 30.6708L19.2012 25.4969C19.2012 25.4969 17.4444 21.8782 17.2561 21.7484L17.2561 28.024C17.2561 28.024 17.2345 28.5505 17.5327 28.9123Z",
    fill: "url(#paint11_linear_707_40756)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2222 21.6808L17.2773 21.7189C17.4681 21.8501 19.0542 25.1099 19.2344 25.4811L19.2383 25.4893L19.2379 25.4986L19.0153 30.7646L17.5069 28.9352C17.2034 28.5672 17.2211 28.0443 17.2222 28.0221L17.2222 21.6808ZM19.1669 25.5047C18.5235 24.1792 17.5564 22.2425 17.2928 21.8473L17.2928 28.0239C17.2925 28.0303 17.2755 28.5428 17.561 28.8893L18.9524 30.5767L19.1669 25.5047Z",
    fill: "#282828"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7575 36.3088C26.9851 37.5149 28.1574 39.4333 28.1574 39.4333C30.1407 39.2249 29.9354 38.3505 29.9354 38.3505L30.0859 33.0332H28.3571C27.8172 34.1762 26.5865 35.4035 26.7575 36.3088Z",
    fill: "url(#paint12_linear_707_40756)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1562 39.4338L25.0593 39.573C25.154 39.5784 26.2613 39.6329 28.1562 39.4338Z",
    fill: "url(#paint13_linear_707_40756)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7531 33.884C22.7605 33.6534 22.7707 33.3639 22.7831 33.0343H20.0175L20.1681 38.3516C20.1681 38.3516 19.9628 39.2264 21.946 39.4344C23.9293 39.6424 25.0508 39.5732 25.0508 39.5732C25.0508 39.5732 22.6983 35.6026 22.7531 33.884Z",
    fill: "url(#paint14_linear_707_40756)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0461 22.941C26.0871 23.2311 26.1896 23.6636 26.3309 24.1858C27.5902 24.2536 29.43 24.429 30.1769 24.8841C30.1769 24.8841 30.4504 24.9767 30.5964 24.6991C30.7423 24.4215 32.657 20.5151 32.657 20.5151C32.657 20.5151 33.0948 20.2558 32.657 19.7006C32.2598 19.1967 31.8779 17.855 26.7715 17.6104C26.6221 18.2538 25.8281 21.3981 26.0461 22.941Z",
    fill: "url(#paint15_linear_707_40756)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4491 20.5164C17.4491 20.5164 19.3638 24.4221 19.5098 24.7C19.6557 24.9776 19.9292 24.8851 19.9292 24.8851C20.3811 24.6097 21.2337 24.4368 22.1152 24.3281C21.576 23.5499 20.9429 22.6181 20.6012 21.4977C20.2228 20.2575 20.2673 18.9075 20.38 17.9571C18.0417 18.4596 17.7494 19.3211 17.4491 19.7023C17.0113 20.2571 17.4491 20.5164 17.4491 20.5164Z",
    fill: "url(#paint16_linear_707_40756)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M25.0523 39.5731L25.0605 39.5727C25.0558 39.5723 25.0527 39.5723 25.0523 39.5723V39.5731Z",
    fill: "#E9E9E9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M25.04 33.0345H22.7861C22.7737 33.3641 22.7635 33.6535 22.756 33.8841C22.7013 35.6027 25.0538 39.5733 25.0538 39.5733V39.5726C25.0541 39.5726 25.0569 39.5729 25.0612 39.5729L28.1581 39.4338C28.1581 39.4338 26.9861 37.515 26.7582 36.3093C26.5872 35.404 27.8179 34.1767 28.3574 33.0337H25.0396L25.04 33.0345Z",
    fill: "url(#paint17_linear_707_40756)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6021 21.4977C20.9438 22.6181 21.577 23.5502 22.1162 24.3281C23.5468 24.1517 25.0545 24.1445 25.0545 24.1445V24.1438C25.0587 24.1438 25.5965 24.1467 26.3328 24.1861C26.1915 23.6643 26.089 23.2314 26.048 22.9412C25.83 21.3983 26.624 18.2541 26.7734 17.611C26.2512 17.5859 25.6802 17.5723 25.0541 17.5723V17.573C22.9401 17.573 21.4476 17.7276 20.3809 17.9568C20.2682 18.9075 20.2241 20.2575 20.6021 21.4977Z",
    fill: "url(#paint18_linear_707_40756)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M20.6021 21.4977C20.9438 22.6181 21.577 23.5502 22.1162 24.3281C23.5468 24.1517 25.0545 24.1445 25.0545 24.1445V24.1438C25.0587 24.1438 25.5965 24.1467 26.3328 24.1861C26.1915 23.6643 26.089 23.2314 26.048 22.9412C25.83 21.3983 26.624 18.2541 26.7734 17.611C26.2512 17.5859 25.6802 17.5723 25.0541 17.5723V17.573C22.9401 17.573 21.4476 17.7276 20.3809 17.9568C20.2682 18.9075 20.2241 20.2575 20.6021 21.4977Z",
    fill: "#E9E9E9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_707_40756",
    x1: 25.1069,
    y1: 39.2748,
    x2: 25.1069,
    y2: 32.8886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#474746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_707_40756",
    x1: 25.105,
    y1: 15.4483,
    x2: 25.105,
    y2: 9.0621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#474746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4385
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_707_40756",
    x1: 17.2347,
    y1: 33.4912,
    x2: 14.0041,
    y2: 30.1161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C43F15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_707_40756",
    x1: 23.3874,
    y1: 44.0513,
    x2: -7.86688,
    y2: 20.5436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C43F15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_707_40756",
    x1: 19.0513,
    y1: 38.0211,
    x2: 6.57171,
    y2: 31.9336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C43F15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_707_40756",
    x1: 22.0747,
    y1: 45.9329,
    x2: 12.86,
    y2: 28.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C43F15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_707_40756",
    x1: 33.7092,
    y1: 33.49,
    x2: 30.4784,
    y2: 30.1141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C43F15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_707_40756",
    x1: 32.7799,
    y1: 44.0505,
    x2: 1.52571,
    y2: 20.5428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C43F15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_707_40756",
    x1: 32.9674,
    y1: 38.0199,
    x2: 20.4877,
    y2: 31.9323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C43F15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_707_40756",
    x1: 33.4165,
    y1: 45.9325,
    x2: 24.2018,
    y2: 28.1625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C43F15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_707_40756",
    x1: 31.8809,
    y1: 38.8238,
    x2: 31.8809,
    y2: 16.8896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542A0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_707_40756",
    x1: 18.2286,
    y1: 38.8249,
    x2: 18.2286,
    y2: 16.8906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542A0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_707_40756",
    x1: 28.4136,
    y1: 45.5711,
    x2: 28.4136,
    y2: 29.4666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542A0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_707_40756",
    x1: 26.6075,
    y1: 45.5712,
    x2: 26.6075,
    y2: 29.4669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542A0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_707_40756",
    x1: 22.5342,
    y1: 45.5711,
    x2: 22.5342,
    y2: 29.4666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542A0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_707_40756",
    x1: 29.4301,
    y1: 31.5958,
    x2: 29.4301,
    y2: 13.5824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542A0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_707_40756",
    x1: 19.6849,
    y1: 31.5961,
    x2: 19.6849,
    y2: 13.5826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542A0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_707_40756",
    x1: 25.5565,
    y1: 45.5712,
    x2: 25.5565,
    y2: 29.4668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542A0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_707_40756",
    x1: 23.5374,
    y1: 31.5964,
    x2: 23.5374,
    y2: 13.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542A0E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar2);
export default __webpack_public_path__ + "static/media/car2.a7b1c11c.svg";
export { ForwardRef as ReactComponent };